import { parseMTDateString } from '../../service-utils';

export const getVideoPlaySrc = (serializedResolutions) => {
  if (serializedResolutions) {
    const resolutionConfig = JSON.parse(serializedResolutions);
    const resolutions = Object.keys(resolutionConfig).map(h => parseInt(h, 10));
    const largestResolution = Math.max(...resolutions);

    return resolutionConfig[largestResolution];
  }

  return null;
};

// for now, we don't support play stream URL yet, so here use DownloadUrl instead of Url.
export const transformVideoResponse = (video, i18n) => ({
  folderAssetType: video.FolderAssetType,

  id: video.IdString,
  createdTime: parseMTDateString(i18n, video.UploadedTime),
  modifiedTime: parseMTDateString(i18n, video.ModifiedTime),
  name: video.Description,
  thumbnailUrl: video.ThumbnailUrl,
  url: getVideoPlaySrc(video.DownloadUrl),
  width: video.Width,
  height: video.Height,
  durationInMS: video.DurationInMS,
  status: video.Status,
  metaData: video.Metadata,
  fileSize: video.SourceVideoLength,
  quality: video.Quality,
  sourceType: video.SourceType,
});
